import { directions } from '../../constants';

const appVersionsText = `Ввести диапазон версий приложения, в рамках которого распространяется событие. Пример значения, 1.44.0.\n
                        В качестве максимальной границы можно задать версию, которой не существует, но известно, что в перспективе событие затронет. Выбрать один из  вариантов:
                        1. ввести минимальную и максимальную границы версий;
                        2. ввести только минимальную границу версии (если отсутствует понимание максимальной границы);
                        3. ввести только максимальную границу версии (если указание минимальной границы нецелесообразно).`;

export const _info = {
  responsible:
    'Ввести ответственного за факт свершения события, в формате name.surname',
  eventType: `client_release - подача, включение версии, включение рекомендуемого/принудительного апдейта версии в сторе;
               server_release - выкат серверных правок в коде на прод;
               config_deploy - заливка конфигов сплитов, акций, фичей и т.д.;
               event_split - включение, выключение экспериментов с разделением пользователей на группы.`,
  dateTime: {
    client_release:
      'Фактическая дата и время открытия/включения версии в сторе, включения апдейта в сторе, подачи в стор, отменены/отключения в сторе, переподачи в сторе (в зависимости от события).',
    server_release: 'Фактическая дата и время deploy на прод.',
    config_deploy: 'Фактическая дата и время deploy на прод.',
    event_split:
      'Фактическая дата и время старта, выключение сплита (т.е. доступно пользователям приложения).',
  },
  appVersion: {
    client_release: 'Ввести версию приложения. Пример значения, 1.44.0',
  },
  maxAppVersion: {
    event_split: appVersionsText,
    config_deploy: appVersionsText,
    server_release: appVersionsText,
  },
  link:
    'Вставить ссылку на release doc (release notes, server release notes, server release splits). Если для события отсутствует документ release notes либо server release notes, тогда вставить ссылку на задачу в Jira.',
  audience:
    'Указать характеристики аудитории, на которую распространяется событие',
};

export const getInfo = values => {
  const info = {};
  Object.entries(_info).forEach(([key, value]) => {
    if (typeof value === 'string') {
      info[key] = value;
    } else {
      info[key] = value[values.eventType];
    }
  });

  if (values.direction === directions.CRM) {
    info.dateTime = 'Указать дату и время возникновения фактического события';
    info.link = 'Ссылка на источник с дополнительной информацией';
    info.eventType = '';
  }

  if (values.direction === directions.BI) {
    info.dateTime = 'Enter date of relese on prod or date of event';
    info.responsible =
      'Enter the person responsible for the topic. Value format name.surname';
    info.link = 'Link on Jira task or documentation';
    info.minAppVersion =
      'Enter the minimum and/or maximum version associated with the event';
    info.maxAppVersion =
      'Enter the minimum and/or maximum version associated with the event';
    info.appVersion = '';
    info.eventType = '';
  }

  return info;
};
